import RandomColor from 'randomcolor'
import {getPartyColors} from './api';
import moment from 'moment';

export function Slug(string){
    return string.split(' ').join('-');
}

export function convertToPercentage(num){
    return (num*100).toFixed(2)+'%'
}
export function convertToFixedTwo(num){
    return (num*100).toFixed(2)
}
export function convertDay(num){
    const days = ['Sunday','Monday','Tuesday','Wednesday','Thursday','Friday','Saturday']
    return days[num]
}

export function convertMonth (num){
    const months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"]
    return months[num]
}

export function convertDateFormat (date){
    //console.log(date);
    //console.log(date+'Z');
    if(moment(date).isValid() === true){
        let newTime = moment(date).format('dddd, MMMM Do YYYY');
       return newTime;
    }else {
        return '';
    }
    let d = new Date(date + 'Z')
    let day = convertDay(d.getDay()), month = convertMonth(d.getMonth()), year = d.getFullYear(), dd = d.getDate();


    return `${day}, ${month} ${dd}, ${year}`
}

export function convertTime(date){
    if(moment(date).isValid() === true){
        let newTime = moment(date).format(' h:mm:ss a') + ' EST';
       return newTime;
    }else {
        return '';
    }
     let d = new Date(date), dd = 'AM'
     let hour = d.getHours(), min = (d.getMinutes()<10?'0':'')+ d.getMinutes(), sec = (d.getSeconds()<10?'0':'')+ d.getSeconds()
     if(hour >= 12){
         hour = hour-12
         dd='PM'
     }

     if(hour == 0) hour = 12

     hour = hour<10 ? ('0'+hour):hour
     return `${hour}:${min}:${sec} ${dd}`
}

export function numFormat(number) {
    let integerPart = number.toLocaleString('en').split('.')[0];
    //let decimalPart = number.toFixed(2).split('.')[1];
    if (isNaN(integerPart.replace(/,/g,""))) return "";
    else return integerPart
}

export function capitalizeString(string){
    let arr = string.split(' ')
    let res = arr.map(ele => {
       return ele.charAt(0).toUpperCase() + ele.toLowerCase().slice(1)
    })
    
    return res.join(' ')
}

export function setColor(num){
        //first 15 colors
        //const colors = [ '#dc4fec','#ffb400', '#4ed03c','#2ecbff','#f2e122','#7408be','#09d29c', '#f9b3c7','#e1f400','#f64243', '#2e9fff','#fc296d','#0088b7','#f0d193','#e26f70']
        // update colors to make them looks not similar to party colors existing.
        const colors = ['#bd9433','#265463', '#4ed03c','#f2e122','#7408be','#09d29c', '#f9b3c7','#e1f400','#ca4c4c', '#40739e','#fc296d','#0088b7','#f0d193','#e26f70','#906b74', '#3cb44b','#4363d8','#f58231', '#911eb4','#46f0f0', '#d47035','#bcf60c', '#fabebe', '#008080', '#e6beff','#329648', '#9a6324', '#800000', '#aaffc3', '#808000', '#ffd8b1', '#000075', '#808080'];
        const length = colors.length

        if(num<length) return colors.slice(0,num)
       
        let colorSet = colors;
       // choose colors the difference among them are greater than 0.85
        for(let i=length; i<num; i++){
            let random = null
            while(!random){
                random = RandomColor();
                //random color should be different with white and hover color
                if((hexColorDelta('#ffffff', random) < 0.8) && hexColorDelta('#fc8d59', random)< 0.85){
                let j=0;
                while(j<colorSet.length){
                        if(hexColorDelta(colorSet[j], random) > 0.85 ){
                            random = null;
                            break;
                        }
                        j++;
                    }
                }else {
                    random = null;
                }
            }
            colorSet.push(random)
        }
     // let randomCls = RandomColor({count:num-length})
      return colorSet
}

export function getPartyColorForOffice(colors, list, electionCode){
    let colorSet=[]
    // const colors = {LIB: '#ffb400', STG:'#4ed03c', REP:'#f64243', DEM:'#2e9fff', writein:'#f2e122', overvotes:'#7408be', undervotes: '#09d29c'}
    list.forEach( candi => {
        if(electionCode == 'G' || electionCode == 'S'){
            if(removeSpecialChar(candi.Contestant).toLowerCase().match('writein')) return colorSet.push(colors['writein'])
        }

        let name = (!candi.PartyCode) ? removeSpecialChar(candi.Contestant).toLowerCase() : candi.PartyCode
        colorSet.push(colors[name]?colors[name]:'#eab085')
    })
    return colorSet
}

export function removeSpecialChar(str){
    const reg = /[^a-zA-Z]+/gm
    return str.replace(reg, '')
}

export function hexColorDelta(hex1, hex2) {
    // get red/green/blue int values of hex1
    hex1 = hex1.replace('#', '')
    hex2 = hex2.replace('#', '')
    var r1 = parseInt(hex1.substring(0, 2), 16);
    var g1 = parseInt(hex1.substring(2, 4), 16);
    var b1 = parseInt(hex1.substring(4, 6), 16);
    // get red/green/blue int values of hex2
    var r2 = parseInt(hex2.substring(0, 2), 16);
    var g2 = parseInt(hex2.substring(2, 4), 16);
    var b2 = parseInt(hex2.substring(4, 6), 16);
    // calculate differences between reds, greens and blues
    var r = 255 - Math.abs(r1 - r2);
    var g = 255 - Math.abs(g1 - g2);
    var b = 255 - Math.abs(b1 - b2);
    // limit differences between 0 and 1
    r /= 255;
    g /= 255;
    b /= 255;
    // 0 means opposit colors, 1 means same colors
    return (r + g + b) / 3;
}


// WEBPACK FOOTER //
// ./src/utils/helper.js